import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';

import { BlueRightArrowIcon, TypeTempAutoIcon } from '../../../../images/icons/WrapSvg';

class Termometre extends React.Component {
    handleClick = (event) => {
        this.props.history.push('/manage/termometres/' + this.props.termometre.id);
    };

    render() {
        const { termometre, last } = this.props;
        const nombre = ` ${termometre.nombre}`;
        return (
            <div
                className={
                    'flex_full_row padding_top_24 padding_left_12 margin_left_24 c_grey_blue hand '
                }
                onClick={this.handleClick}
            >
                <TypeTempAutoIcon className={'margin_right_12'} />
                <div
                    className={classNames(
                        'flex_full_row  align_center padding_bottom_9',
                        last ? 'noshadow' : 'shadow_down',
                    )}
                >
                    <div className={'flex_full_row '}>
                        <span className="barlow_medium c_dark_grey_blue">{nombre}</span>
                    </div>
                    <BlueRightArrowIcon color="primary" />
                </div>
            </div>
        );
    }
}

Termometre.propTypes = {
    history: PropTypes.object.isRequired,
};

export default withRouter(Termometre);



// WEBPACK FOOTER //
// ./src/components/complex/manage/termometres/Termometre.js